// Slick Sliders
(function($){
        if (document.getElementById('sliderbgImageUL')) {
            $('#sliderbgImageUL').slick({
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 500,
                dots: true,
                appendDots: $(".slider-controls"),
                arrows: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                swipeToSlide: true,
                margin:10,
                pauseOnHover:false          
            });
        }

    if (document.getElementById('aceCourseSlider')) {
        $('#aceCourseSlider').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 750,
            dots: false,
            appendDots: $(".slider-controls"),
            arrows:true,
            variableWidth: false,
            prevArrow:"<button type='button' class='slick-prev'></button>",
            nextArrow:"<button type='button' class='slick-next'></button>",
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            swipe: true,
            swipeToSlide: true,
            margin:10,
            pauseOnHover:false,
            responsive: [
                            {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  arrows:false,
                }
              },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows:false,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:false,
                  }
                }   
            ]   
        });
    }

    if (document.getElementById('aceTailorMadeSlider')) {
        $('#aceTailorMadeSlider').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 750,
            dots: true,
            arrows: true,
            prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
            nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            swipe: true,
            swipeToSlide: true,
            margin:10,
            pauseOnHover:false,
            responsive: [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  arrows:false,
                }
              },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows:false,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:false,
                  }
                }   
            ]          
        });
    }


    var blockLoaded = false;
    var blockLoadedInterval = setInterval(function() {
        if (document.getElementById('aceCaseStudiesSlider')) {
            $('#aceCaseStudiesSlider').slick({
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 750,
                dots: true,
                arrows: true,
                prevArrow:"<button class='slick-btn-wrap slick-btn-left' type='button'><i class='fas fa-chevron-left'></i></button>",
                nextArrow:"<button class='slick-btn-wrap slick-btn-right' type='button'><i class='fas fa-chevron-right'></i></button>",
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                swipeToSlide: true,
                margin:10,
                pauseOnHover:false,
                
            });
            blockLoaded = true;
        }
        
        if ( blockLoaded ) {
            clearInterval( blockLoadedInterval );
        }
    }, 500);


    if (document.getElementById('c-ace--personalized-training-slider')) {
        $('#c-ace--personalized-training-slider').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 750,
            dots: false,
            appendDots: $(".slider-controls"),
            arrows:true,
            prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
            nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            swipe: true,
            swipeToSlide: true,
            margin:10,
            pauseOnHover:false,
            responsive: [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  arrows:false,
                }
              },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows:false,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:false,
                  }
                }   
            ]   
        });
    }



})(jQuery);
